import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardImg } from 'reactstrap';
import { Link } from 'react-router-dom';

const ClientItem = ({ item }) => (
  <div className="client-item">
    <Card>
      <Link to={item.url}>
        <CardImg
          className="image"
          src={item.image}
        />
        <div className="content">
          <div className="subtitle">{item.city}</div>
          <div className="title">{item.name}</div>
        </div>
      </Link>
      {item.digitalShowUrl && (
      <div className="digital-show-button">
        <button
          type="button"
          className="live-button"
          aria-label="Open"
          onClick={() => window.open(item.digitalShowUrl, '_blank')}
        ><span>Digital Show</span>
        </button>
      </div>
      )}
    </Card>
  </div>
);

ClientItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    digitalShowUrl: PropTypes.string,
  }).isRequired,
};

export default ClientItem;
